<template>
  <div class="navbar">
    <div class="ys-NavbarBox">
      <div class="ys-nav-logo" @click="putRouter('index')">
        <img src="@/assets/images/newimg/wash_logo.png" alt="共享洗衣" v-if="!styleObj.img">
        <img src="@/assets/images/newimg/logoColor.png" alt="共享洗衣" v-if="styleObj.img">
        <p v-if="styleObj.title">广东赢时科技有限公司</p>
      </div>
      <div class="ys-nav-menu">
        <div
          :class="['ys-minMenuBtn', !ysIndexSwiperRightBtn || 'ys-menuOpen', !styleObj.img || 'spanStyle']"
          @click="openMenu(!ysIndexSwiperRightBtn)"
          ref="minMenuBtn"
          v-if="!styleObj.menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div :class="styleObj.menu || ['ys-menuBoxPosition']">
          <side-menu
            :openMenu="ysIndexSwiperRightBtn"
            :indexOne="!styleObj.menu"
            :menuColor="styleObj.menuColor"
          ></side-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SideMenu from '../menu/menu.vue'
  import {mapMutations} from 'vuex'

  export default {
// BY zgc19 ON 2019/1/17
    name: 'navbar',
    props: {
      styleObj: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data () {
      return {
        windowWidth: this.$store.state.app.windowWidth,
        openMenuBtnLocation: {},
        getPositionPx: {},
        ysIndexSwiperRightBtn: this.$store.state.app.indexSwiperRightBtn
      }
    },
    created () {
      // this.getIndexSwiperRightBtn(this.ysIndexSwiperRightBtn)
    },
    watch: {
      '$store.state.app.indexSwiperRightBtn' (to) {
        this.ysIndexSwiperRightBtn = to
      }
    },
    methods: {
      ...mapMutations(['getIndexSwiperRightBtn']),
      openMenu (v) {
        this.ysIndexSwiperRightBtn = v
        this.getIndexSwiperRightBtn(v)
      },
      putRouter (v) {
        this.$router.push({name: v})
      }
    },
    mounted () {
      // let obj = this.$refs.minMenuBtn.getBoundingClientRect()
      // let winWindth = this.$store.getters.windowWidth
      // this.getPosition(60, winWindth - obj.right)
    },
    components: {
      SideMenu
    }
  }
</script>

<style scoped lang="scss">
  @function p2r($size) {
    @return $size/75 * 1rem;
  }

  .ys-minMenuBtn {
    z-index: 20;

    span {
      display: block;
      background: #fff;
      transition: all .2s;

      &:nth-child(2) {
        opacity: 1;
      }
    }
  }

  @media screen and (min-width: 750px) {
    .ys-minMenuBtn {
      width: 24px;
      height: 26px;

      span {
        height: 4.33px;
        margin: 3px 0;
      }

      &.ys-menuOpen {
        span:nth-child(1) {
          transform: translate(0px, 8px) rotate(45deg);
        }

        span:nth-child(3) {
          transform: translate(0px, -6px) rotate(-45deg);
        }

        span:nth-child(2) {
          opacity: 0;
        }
      }
    }
    .navbar {

      .ys-NavbarBox {
        height: 80px;
        display: flex;
        align-items: center;

        .ys-nav-logo,
        .ys-nav-menu {
          padding: 0 60px;
          flex: 1;
        }

        .ys-nav-logo {
          cursor: pointer;
          display: flex;
          align-items: center;

          p {
            font-size: 15px;
            color: #fff;
            padding-left: 20px;
          }

          img {
            width: 120px;
            height: 36px;
          }
        }

        .ys-nav-menu {
          z-index: 99;
          display: flex;
          flex-direction: row-reverse;

          .ys-menuBoxPosition {
            position: fixed;
            top: 0;
            right: 0;
          }

        }

      }
    }
  }

  @media screen and (max-width: 750px) {
    .ys-minMenuBtn {
      width: p2r(26);
      height: p2r(24);
      display: flex;
      flex-direction: column-reverse;

      &.spanStyle span {
        background: rgb(51, 51, 51);
      }

      span {
        flex: 1;
        transition: all .5s;

        &:nth-child(2) {
          margin: p2r(4) 0;
        }
      }

      &.ys-menuOpen {
        span:nth-child(1) {
          transform: translate(0px, p2r(-9)) rotate(45deg);
        }

        span:nth-child(3) {
          transform: translate(0px, p2r(9)) rotate(-45deg);
        }

        span:nth-child(2) {
          opacity: 0;
        }
      }
    }

    .navbar {

      .ys-NavbarBox {
        height: p2r(100);
        display: flex;
        align-items: center;

        .ys-nav-logo,
        .ys-nav-menu {
          padding: 0 p2r(30);
          flex: 1;
        }

        .ys-nav-logo {
          cursor: pointer;
          display: flex;
          align-items: center;

          p {
            font-size: p2r(15);
            color: #fff;
            padding-left: p2r(20);
          }

          img {
            width: 120px;
            height: 36px;
          }
        }

        .ys-nav-menu {
          z-index: 99;
          display: flex;
          flex-direction: row-reverse;

          .ys-menuBoxPosition {
            position: fixed;
            top: 0;
            right: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar.vue